import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { MdErrorOutline } from "react-icons/md";

type Props = {
  errorMsg?: string;
};

const ErrorSection = ({ errorMsg = "" }: Props) => {
  const theme = useTheme();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap="16px"
      marginTop="3rem"
    >
      <MdErrorOutline size={128} color={theme.palette.error.main} />
      <Typography variant="h3" color="error">
        حدث خطأ
      </Typography>
      <Typography variant="h4">{errorMsg}</Typography>
    </Stack>
  );
};

export default ErrorSection;
